import React from "react"
import { useGlobal } from 'reactn'
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import Nav from "./nav"
import "./layout.css"
import { useEffect } from 'react'
import ConnectModal from '../components/connect-modal'
import Footer from './footer'

const Layout = ({ children, location }) => {

  // global state vars

  const [showConnectModal, setShowConnectModal] = useGlobal('showConnectModal')

  useEffect(() => {
    if (typeof window !== `undefined`) {
      window.scrollTo(0, 0)
    }
  }, [])

  const closeConnectModal = () => {
    setShowConnectModal(false)
  }

    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <div id='layout-wrapper'>    
            <Nav siteTitle={data.site.siteMetadata.title} location={location} />        
            <div id='main-content'>
              <main>
                <ConnectModal isOpen={showConnectModal} onRequestClose={closeConnectModal}/>   
                {children}
              </main>
            </div>
            <Footer />
          </div>
        )}
      />
    )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
